<template>
	<div class="newComing">
		  <div class="newComing_top">
			  <transition enter-active-class="animated bounceIn">
						<div class="newComing_top_h1" v-show="newComing_top_show"></div>
			  </transition>
			   <div class="newComing_top_text">
				   <p class="newComing_top_text_p1">更多潮流新品</p>
				   <p class="newComing_top_text_p2">尽在<span class="newComing_top_text_p3">Carlton</span>
				   <i class="iconfont icon-shape3"></i>
				  </p>
				 
			   </div>
			   
		  </div>
		  <div class="newComing_deatil1"> 
		  </div>
		  <div class="newComing_goods">
                 
			  <div class="newComing_goods_left">
				   <img src="../../../../static/img/newComing/021abd59a62fe4a4f43b41fdeff9dd5f05.jpg" width="430px" height="300px">
			  </div>
			  <div class="newComing_goods_right">
				    <div class="newComing_goods_right_text">
						 <h1>VANS ERA VN【JP LINE】</h1>
						 <div>Vans（范斯）是1966年诞生于美国南加州的原创极限运动潮牌，致力于在发展原创性的同时支持全世界的板类和车类运动。Vans源于年轻，纯正和个性化风格，呈现出代表极限运动以及年轻文化核心的创造和自我表现力。</div>
					</div>
			        <router-link to="/shopsGoods/kkxc000" class="newComing_goods_ToSee">了解更多 <i class="iconfont icon-arrow_left"></i></router-link>
              </div>
                
		  </div>
		  <div class="newComing_deatil2"></div>
		  <!-- 商品详情介绍 -->
		  <div class="newComing_goods">
			    <div class="newComing_goods_left">
                 <img src="../../../../static/img/newComing/01de7d5e080b8a215cb23e5e3644ce761e.jpg"   width="450px" height="300px">
				</div>
				 <div class="newComing_goods_right">
				    <div class="newComing_goods_right_text">
						 <h1>adidas Originals NMD_R1 休闲运动鞋</h1>
						 <div>这款NMD经典鞋，结合80年代跑步鞋式样，线条分明。拉伸格子布鞋面，搭配中底，脚感舒适。Boost中底，Boost技术，标志性NMD细节，足内侧模制乙烯/乙酸乙烯酯（EVA）中底插片，旨在彰显NMD美学。</div>
					</div>
				         <router-link class="newComing_goods_ToSee" to='/shopsGoods/2232337788'>了解更多 <i class="iconfont icon-arrow_left"></i></router-link>
		
		            </div>
		  </div>
	</div>
</template>

<script >
	export default {
		data() {
			return {
                   newComing_top_show:false
			}
		},
		mounted(){
                this.newComing_top_show1();
		},
		methods:{
			 newComing_top_show1:function(){
				   this.newComing_top_show = true
			 }
		}
	}
</script>

<style >
   .newComing{
	   width: 100%;
	   height: 100%;
	   background:  #f4f1e9;
   }
 /* .newComing div{
	 height: 100vh;
 } */
 .newComing_top{
   width: 100%;
   height: 700px;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
   background-image: url(../../../../static/img/newComing/愿望清单.png);
   /* background-size: cover; */
   /* background-position: center; */ 
    box-shadow: 0 0 20px #9e9e9e;
   margin: 0 auto;
   padding-top:30px;
 }

 .newComing_top_h1{
	 
	  width:80%;
	  height: 80%;
	  background-image: url(../../../../static/img/newComing/014976b284787e4b9253d317253ce64516.jpg);
	 background-size: cover;
    background-position: center;
	border-radius: 15px;
	box-shadow: 0 0 20px black;

	  /* background: #363635b2; */
	  /* background: rgba(0, 0, 0, 0.288); */
	
 }

 .newComing_top_h1 h1{
	   color: rgb(226, 119, 119);
	   font-size: 30px;
	   font-family: 'SimHei';
 }

 .newComing_top_text{
	 position: relative;
	 bottom: -10px;
	 margin: 10px;
	  width: 100%;
	  height: 30%;
	  /* background: rgba(163, 212, 188, 0.993); */
	  background: #f4f1e9;
	  box-shadow: 0 0 20px #9e9e9e;
 }
 /* 文字宣传语部分 */
.newComing_top_text_p1{
	margin-top: 30px;
	 margin-left: 400px;
	 color: #333;
	 font-style:italic;
	 font-weight: 700;
	 font-size: 40px;
	 font-family: 'SimHei'
}
.newComing_top_text_p2{
	margin-top: 30px;
	 margin-left: 600px;
	 color: #333;
	 font-style:italic;
	 font-weight: 700;
	 font-size: 40px;
	 font-family: 'SimHei'
}
.newComing_top_text_p3{
	
	 color: rgb(245, 61, 61);
	 font-style:italic;
	 font-weight: 700;
	 font-size: 50px;
	  font-family:'Tahoma','Helvetica','Arial';
}
.icon-shape3{
	  color: rgb(33, 173, 127);
	  font-size: 40px;
}

   .newComing_goods{
	   align-items: center;
	   width: 100%;
	   height: 300px;
	   /* background: #f4f1e9; */
	   background: white;
	   display: flex;
	   align-items: center;
	   flex-direction: row;
	   justify-content: space-around;
   }
   .newComing_goods_left{
	margin-left: 50px;
	   
	    display: inline-block;
	    width: 30%;
		height: 100%;
   }

   .newComing_goods_right{
	   width: 500px;
	   height: 300px;
	   
	   /* background: skyblue; */
	   
   }
   .newComing_goods_right_text{
       width: 100%;
	   height: 180px;
	   /* background: rebeccapurple; */

   }
   .newComing_goods_right_text h1{
	   width: 100%;
	   height: 40px;
	   color: #333;
	   text-align: center;
	   line-height: 40px;
	   margin-top: 20px;
	   font-size: 20px;
	   font-family: 'SimHei';
   }
    .newComing_goods_right_text div{
		width: 80%;
		height: 120px;
		/* line-height: 120px; */
		text-align: center;
		margin: 0 auto;
		color: #333;
		padding: 20px;
		box-sizing: border-box;
		 font-size: 15px;
	   font-family: 'SimHei';

	}
   .newComing_goods_ToSee{
	   
		width: 200px;
		height: 50px;
		background: #333;
		color: aliceblue;
		border-radius: 10px;
		border: none;
		margin: 0 auto;
		display: block;
		cursor: pointer;
		text-decoration: none;
		line-height: 50px;
		text-align: center;
		outline: rgb(33, 236, 192);
		font-family: 'SimHei'
   }

   .newComing_goods span{
	   position: relative;
	   top: -100px;
	   display: inline;
	    color: #333;
		font-size:15px;
		font-family: 'SimHei'
   }
   .newComing_deatil1{
	   width: 100%;
	   height: 500px;
	   background-image: url(../../../../static/img/newComing/dsdsdds.jpg);
	   background-size: cover;
	   background-position:top;
	   background-attachment: fixed;
   }
   .newComing_deatil2{
	   width: 100%;
	   height: 500px;
	   background-image: url(../../../../static/img/newComing/237797.jpg);
	   background-size: cover;
	   background-attachment: fixed;
   }

  
</style>


// WEBPACK FOOTER //
// src/components/top/newcoming/newComing.vue